module.exports = __webpack_public_path__ + "static/media/camera-home.1dd62c5a.svg";